<template>
    <div
        v-if="reservation && metadata.subscriber.has_cc_gateway && metadata.permissions.billing_view"
        class="guest-invoices-billing"
    >
        <div v-show="showBillingDetails" class="pt-4">
            <validation-observer ref="form" v-slot="{ meta, setFieldValue, errors }" as="span" validateOnMount>
                <card :header-content-class="['w-100']" class="ml-3 mr-3 mb-3 pb-4 guest-invoices-billing__card">
                    <template #header-icon>
                        <font-awesome-icon
                            class="guest-invoices-billing__card__header-icon"
                            :icon="['fas', 'credit-card']"
                            size="lg"
                        />
                    </template>
                    <template #header-content>
                        <div class="guest-invoices-billing__card__title">
                            Billing Details
                            <font-awesome-icon
                                class="guest-invoices-billing__card__title__icon text-success"
                                :icon="['fas', 'lock']"
                                size="lg"
                            />
                        </div>
                    </template>
                    <template #body>
                        <b-row>
                            <b-col md="8" lg="4" class="guest-invoices-billing__card__body">
                                <b-button
                                    v-if="
                                        reservation.payment_method_confirmation_status ===
                                            PAYMENT_METHOD_CONFIRMATION_STATUS_FAILED &&
                                        reservation.payment_method_confirmation_error &&
                                        showPreviewCard
                                    "
                                    class="status-message mb-3"
                                    variant="outline-danger"
                                    @click="$bvModal.show(confirmationFailedModalId)"
                                >
                                    CONFIRMATION FAILED
                                </b-button>
                                <b-button
                                    v-else-if="
                                        reservation.payment_method_confirmation_status ===
                                            PAYMENT_METHOD_CONFIRMATION_STATUS_PENDING && showPreviewCard
                                    "
                                    class="status-message mb-3"
                                    variant="outline-warning"
                                    @click="$bvModal.show(pendingConfirmationModalId)"
                                >
                                    PENDING CONFIRMATION
                                </b-button>
                                <billing-card-preview
                                    v-if="showPreviewCard && isCreditCard"
                                    :billingCard="displayBillingCard"
                                    @toggleCardEdit="toggleCardEdit"
                                />
                                <billing-card-preview
                                    v-if="showPreviewCard && isECheck"
                                    :billingCard="displayBillingCard"
                                    @toggleCardEdit="toggleCardEdit"
                                    showCard="echeck"
                                />
                                <b-button
                                    v-if="
                                        reservation.payment_method_confirmation_status ===
                                            PAYMENT_METHOD_CONFIRMATION_STATUS_FAILED &&
                                        reservation.payment_method_confirmation_error &&
                                        showPreviewCard
                                    "
                                    class="status-message mt-3"
                                    variant="outline-danger"
                                    @click="$bvModal.show(confirmationFailedModalId)"
                                >
                                    CONFIRMATION FAILED
                                </b-button>
                                <b-button
                                    v-else-if="
                                        reservation.payment_method_confirmation_status ===
                                            PAYMENT_METHOD_CONFIRMATION_STATUS_PENDING && showPreviewCard
                                    "
                                    class="status-message mt-3"
                                    variant="outline-warning"
                                    @click="$bvModal.show(pendingConfirmationModalId)"
                                >
                                    PENDING CONFIRMATION
                                </b-button>
                                <span v-show="showEditCard || isNil(cardData)">
                                    <b-row v-if="profileTypeOptions.length > 1" class="mt-3">
                                        <b-col md="12">
                                            <form-select
                                                v-model="billingCard.profileType"
                                                floating-label="PROFILE TYPE"
                                                :options="profileTypeOptions"
                                            />
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3" v-if="isProxy && isCreditCard">
                                        <b-col md="12">
                                            <channex-card-capture
                                                ref="capture"
                                                :valid-payment-card-types="acceptedCards"
                                                @success-tokenize-card="handleSuccessTokenizeCard"
                                            />
                                        </b-col>
                                    </b-row>
                                    <div v-else-if="isProxy == false || isECheck">
                                        <span v-if="isCreditCard">
                                            <span>
                                                <b-row v-if="metadata.use_setup_intent_guest">
                                                    <b-col md="12">
                                                        <validation-provider
                                                            name="stripe_setup_intent"
                                                            rules="required|validStripeSetupIntent"
                                                        >
                                                            <form-stripe-card
                                                                v-model="reservation.stripe_setup_intent"
                                                                :client-secret="reservation.stripe_client_secret"
                                                                :publishable-key="metadata.stripe_publishable_key"
                                                                :stripe-account="metadata.stripe_account"
                                                                :valid-payment-card-types="acceptedCards"
                                                                :error="errors.stripe_setup_intent"
                                                                @input="
                                                                    (val) => setFieldValue('stripe_setup_intent', val)
                                                                "
                                                            />
                                                        </validation-provider>
                                                    </b-col>
                                                </b-row>
                                                <span v-if="!metadata.use_setup_intent_guest">
                                                    <b-row>
                                                        <b-col md="12">
                                                            <validation-provider
                                                                ref="cardNumber"
                                                                name="card_number"
                                                                :rules="{
                                                                    required: true,
                                                                    validPaymentCardNumber: {
                                                                        validPaymentCardTypes: acceptedCards,
                                                                    },
                                                                }"
                                                            >
                                                                <form-input
                                                                    name="cc-number"
                                                                    autocomplete="cc-number"
                                                                    data-card-field
                                                                    v-model="cardNumber"
                                                                    v-mask="cardNumberMask"
                                                                    floating-label="CARD NUMBER"
                                                                    :error="errors.card_number"
                                                                    @input="(val) => setFieldValue('card_number', val)"
                                                                />
                                                            </validation-provider>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col md="6">
                                                            <validation-provider
                                                                name="cardExpirationDate"
                                                                rules="required|validPaymentCardExpiry"
                                                                v-slot="{ errors }"
                                                                
                                                            >
                                                                <form-input
                                                                    name="cc-exp"
                                                                    autocomplete="cc-exp"
                                                                    data-card-field
                                                                    v-model="billingCard.cardExpirationDate"
                                                                    v-mask="cardExpiryMask"
                                                                    floating-label="MM/YY"
                                                                    :error="errors.cardExpirationDate"
                                                                    @input="
                                                                        (val) =>
                                                                            setFieldValue('cardExpirationDate', val)
                                                                    "
                                                                />
                                                            </validation-provider>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <validation-provider
                                                                name="cardCvv"
                                                                :rules="`required|validPaymentCardCvv:${cardCvvLength}`"
                                                                
                                                            >
                                                                <form-input
                                                                    name="cc-csc"
                                                                    autocomplete="cc-csc"
                                                                    data-card-field
                                                                    v-model="billingCard.cardCvv"
                                                                    v-mask="cardCvvMask"
                                                                    :floating-label="cardCvvLabel"
                                                                    :error="errors.cardCvv"
                                                                    @input="(val) => setFieldValue('cardCvv', val)"
                                                                />
                                                            </validation-provider>
                                                        </b-col>
                                                    </b-row>
                                                </span>
                                                <b-row>
                                                    <b-col md="12">
                                                        <validation-provider
                                                            name="cardHolder"
                                                            rules="required|validPaymentCardholderName"
                                                        >
                                                            <form-input
                                                                data-card-field
                                                                name="cc-name"
                                                                autocomplete="cc-name"
                                                                v-model="billingCard.cardHolder"
                                                                floating-label="CARDHOLDER NAME"
                                                                :error="errors.cardHolder"
                                                                @input="(val) => setFieldValue('cardHolder', val)"
                                                            />
                                                        </validation-provider>
                                                    </b-col>
                                                </b-row>
                                            </span>
                                        </span>
                                        <span v-if="isECheck" class="lx-online-booking-checkout-payment__echeck">
                                            <b-row>
                                                <b-col md="12">
                                                    <validation-provider
                                                        name="eCheckRoutingNumber"
                                                        rules="required|validRoutingNumber"
                                                    >
                                                        <form-input
                                                            v-model="billingCard.eCheckRoutingNumber"
                                                            floating-label="ROUTING NUMBER"
                                                            :error="errors.eCheckRoutingNumber"
                                                            @input="(val) => setFieldValue('eCheckRoutingNumber', val)"
                                                        />
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col md="12">
                                                    <validation-provider
                                                        name="eCheckAccountNumber"
                                                        rules="required|validAccountNumber"
                                                    >
                                                        <form-input
                                                            v-model="billingCard.eCheckAccountNumber"
                                                            floating-label="ACCOUNT NUMBER"
                                                            :error="errors.eCheckAccountNumber"
                                                            @input="(val) => setFieldValue('eCheckAccountNumber', val)"
                                                        />
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="metadata.use_setup_intent_guest">
                                                <b-col md="12">
                                                    <validation-provider
                                                        name="eCheckAccountHolderName"
                                                        rules="required|maxMessageLen:23, Account name"
                                                    >
                                                        <form-input
                                                            v-model="eCheckAccountHolderName"
                                                            :leftIcon="['fas', 'user']"
                                                            autocomplete="cc-name"
                                                            floating-label="FULL NAME"
                                                            :error="errors.eCheckAccountHolderName"
                                                            @input="
                                                                (val) => setFieldValue('eCheckAccountHolderName', val)
                                                            "
                                                        />
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="metadata.use_setup_intent_guest">
                                                <b-col md="12">
                                                    <validation-provider
                                                        name="eCheckEmail"
                                                        rules="email|required"
                                                        
                                                    >
                                                        <form-input
                                                            v-model="eCheckEmail"
                                                            :leftIcon="['fas', 'at']"
                                                            autocomplete="email"
                                                            floatingLabel="EMAIL"
                                                            :error="errors.eCheckEmail"
                                                            @input="(val) => setFieldValue('eCheckEmail', val)"
                                                        ></form-input>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="!metadata.use_setup_intent_guest">
                                                <b-col md="12">
                                                    <validation-provider
                                                        name="eCheckAccountName"
                                                        rules="required|maxMessageLen:23, Account name"
                                                    >
                                                        <form-input
                                                            v-model="billingCard.eCheckAccountName"
                                                            floating-label="ACCOUNT NAME"
                                                            :error="errors.eCheckAccountName"
                                                            @input="(val) => setFieldValue('eCheckAccountName', val)"
                                                        />
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="!metadata.use_setup_intent_guest">
                                                <b-col md="12">
                                                    <validation-provider
                                                        name="eCheckBankName"
                                                        rules="required|maxMessageLen:51, Bank name"
                                                    >
                                                        <form-input
                                                            v-model="billingCard.eCheckBankName"
                                                            floating-label="BANK NAME"
                                                            :error="errors.eCheckBankName"
                                                            @input="(val) => setFieldValue('eCheckBankName', val)"
                                                        />
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col md="6">
                                                    <form-select
                                                        v-model="billingCard.eCheckAccountType"
                                                        floating-label="ACCOUNT TYPE"
                                                        :options="accountTypeOptions"
                                                    />
                                                </b-col>
                                                <b-col md="6">
                                                    <form-select
                                                        v-model="billingCard.eCheckCheckType"
                                                        floating-label="CHECK TYPE"
                                                        :options="checkTypeOptions"
                                                    />
                                                </b-col>
                                            </b-row>
                                            <span
                                                v-if="eCheckDetails"
                                                class="guest-invoices-billing__card__echeck-details"
                                                >{{ eCheckDetails }}</span
                                            >
                                        </span>
                                    </div>
                                    <b-row v-if="!isNil(isProxy)" class="mt-3">
                                        <b-col class="guest-invoices-billing__card__card-buttons" md="12">
                                            <b-button
                                                class="mr-2"
                                                variant="default"
                                                v-if="!isNil(cardData)"
                                                @click="onCancel"
                                                ><font-awesome-icon class="mr-2" :icon="['fas', 'xmark']" size="lg" />
                                                Cancel</b-button
                                            >
                                            <b-button
                                                variant="outline-primary"
                                                @click="submitCard"
                                                :disabled="!meta.valid"
                                                ><font-awesome-icon
                                                    class="mr-2"
                                                    :icon="['fas', 'floppy-disk']"
                                                    size="lg"
                                                />
                                                Save</b-button
                                            >
                                        </b-col>
                                    </b-row>
                                </span>
                            </b-col>
                            <billing-card-icons
                                :showIcons="
                                    isCreditCard
                                        ? 'credit-card'
                                        : isECheck && metadata.use_setup_intent_guest
                                        ? 'ach-direct-debit'
                                        : isECheck
                                        ? 'echeck'
                                        : ''
                                "
                                :acceptedCards="acceptedCards"
                            />
                            <b-col
                                v-if="
                                    !showEditCard &&
                                    reservation.process_payment_data &&
                                    metadata.permissions.billing_view
                                "
                                class="guest-invoices-billing__card__delete-billing-data"
                                md="8"
                                lg="2"
                            >
                                <responsive-button
                                    :icon="['fas', 'trash']"
                                    variant="outline-primary"
                                    :responsiveness="false"
                                    :withSpace="false"
                                    @click="$bvModal.show(deleteBillingDataModalId)"
                                    >Delete Billing Data
                                </responsive-button>
                            </b-col>
                        </b-row>
                    </template>
                </card>
                <modal
                    :id="subscriptionErrorModalId"
                    title="Subscription Error"
                    header-bg-variant="danger"
                    header-text-variant="light"
                    ok-only
                >
                    <span v-html="errorModalMessage"></span>
                </modal>
                <modal
                    :id="deleteBillingDataModalId"
                    title="Delete Reservation Billing Data"
                    @ok.prevent="deleteBillingData"
                >
                    This action will remove
                    {{ isCreditCard ? 'card' : 'bank' }} details for this reservation. Are you sure you want to delete
                    billing data?
                </modal>
                <modal
                    :id="pendingConfirmationModalId"
                    title="Pending Confirmation (Microdeposits)"
                    @hidden="showPendingConfirmationModal = false"
                >
                    The guest should expect a $0.01 deposit to the bank account in 1-2 business days and an email with
                    additional instructions to verify it. Verification attempts have a limit of three failures. If this
                    limit is exceeded, we can no longer verify the bank account. In addition, microdeposit verifications
                    have a timeout of 10 days. If the guest can’t verify microdeposits in time, you will need to request
                    a payment.
                </modal>
                <modal
                    :id="confirmationFailedModalId"
                    title="Confirmation Failed"
                    @hidden="showConfirmationFailedModal = false"
                >
                    {{ reservation.payment_method_confirmation_error }}
                </modal>
            </validation-observer>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';
    import * as paymentCardValidator from 'card-validator';
    import isNil from 'lodash/isNil';
    import API from '../../../../../api.jsx';
    import Card from '../../../../generic/card/card.vue';
    import Modal from '../../../../generic/modal/modal.vue';
    import FormInput from '../../../../generic/form-input/form-input.vue';
    import FormSelect from '../../../../generic/form-select/form-select.vue';
    import FormCheckbox from '../../../../generic/form-checkbox/form-checkbox.vue';
    import ResponsiveButton from '../../../../generic/responsive-button/responsive-button.vue';
    import ChannexCardCapture from '../../../../generic/channex-card-capture/channex-card-capture.vue';
    import BillingCardPreview from '../../../../generic/billing-card-preview/billing-card-preview.vue';
    import BillingCardIcons from '../../../../generic/billing-card-icons/billing-card-icons.vue';
    import FormStripeCard from '../../../../generic/form-stripe-card/form-stripe-card.vue';
    import { formatResponseError } from '../../../../../utils/api';
    import {
        PAYMENT_METHOD_CONFIRMATION_STATUS_FAILED,
        PAYMENT_METHOD_CONFIRMATION_STATUS_PENDING,
        convertFromBraintreeCardType,
    } from '../../../../../constants';
    import { maskNumber } from '../../../../../utils/strings';
    import {
        GUEST_RESERVATION_ADD_BILLING_DATA_ENDPOINT,
        GUEST_RESERVATION_DELETE_BILLING_DATA_ENDPOINT,
        GUEST_RESERVATION_ADD_BILLING_DATA_STRIPE_ENDPOINT,
    } from '../../../../../endpoints.js';

    export default {
        name: 'GuestInvoicesBillingTab',
        components: {
            Card,
            Modal,
            FormInput,
            FormSelect,
            FormCheckbox,
            ResponsiveButton,
            ChannexCardCapture,
            BillingCardPreview,
            BillingCardIcons,
            FormStripeCard,
        },
        mounted() {
            this.displayBillingCard = this.getBillingCardData(this.cardData);
            this.billingCard.profileType = this.cardData?.profile_type || 0;
            if (this.metadata.use_setup_intent_guest && this.isECheck) {
                (async () => {
                    await this.$store.dispatch('stripe/loadStripe', {
                        publishableKey: this.metadata.stripe_publishable_key,
                        stripeAccount: this.metadata.stripe_account,
                    });
                })();
            }
        },
        data() {
            return {
                cardNumberMask: '#### #### #### ####',
                cardExpiryMask: '##/##',
                cardCvvMask: '###',
                cardCvvLabel: 'CVV',
                cardCvvLength: 3,
                dataDescriptor: null,
                dataValue: null,
                cardToken: null,
                setupIntentId: null,
                setupIntent: null,
                eCheckEmail: '',
                eCheckAccountHolderName: '',
                billingCard: this.getBillingCardData({}),
                displayBillingCard: null,
                deleteBillingDataModalId: 'delete-billing-data-modal-id',
                subscriptionErrorModalId: 'subscription-error-modal-id',
                pendingConfirmationModalId: 'pending-confirmation-modal-id',
                confirmationFailedModalId: 'confirmation-failed-modal-id',
                PAYMENT_METHOD_CONFIRMATION_STATUS_FAILED: PAYMENT_METHOD_CONFIRMATION_STATUS_FAILED,
                PAYMENT_METHOD_CONFIRMATION_STATUS_PENDING: PAYMENT_METHOD_CONFIRMATION_STATUS_PENDING,
                showPendingConfirmationModal: false,
                showConfirmationFailedModal: false,
                showBillingDetails: true,
                showEditCard: false,
                errorModalMessage: '',
                acceptJS: null,
                accountTypeOptions: ['Checking', 'Savings'],
                checkTypeOptions: ['Personal', 'Business'],
            };
        },
        inject: ['showSuccessToast', 'showErrorToast'],
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            ...mapGetters('guest', ['metadata', 'reservation']),
            ...mapGetters('stripe', ['stripe', 'card']),
            guestId() {
                return parseInt(this.$route.params.id);
            },
            cardData() {
                return this.reservation.process_payment_data;
            },
            acceptedCards() {
                return this.metadata.accepted_cards;
            },
            profileTypeOptions() {
                return this.metadata.profile_type_choices;
            },
            eCheckDetails() {
                return this.metadata.echeck_details;
            },
            isCreditCard() {
                return this.billingCard.profileType == 0;
            },
            isECheck() {
                return this.billingCard.profileType == 1;
            },
            showPreviewCard() {
                return !isNil(this.cardData) && !isNil(this.displayBillingCard) && !this.showEditCard;
            },
            isProxy() {
                return this.metadata.is_proxy;
            },
            cardNumber: {
                get() {
                    return this.billingCard.cardNumber;
                },
                set(cardNumber) {
                    this.billingCard.cardNumber = cardNumber;

                    const { card } = paymentCardValidator.number(cardNumber);
                    if (card) {
                        this.billingCard.cardType = convertFromBraintreeCardType(card.type);
                        this.cardCvvLabel = card.code.name;
                        this.cardCvvLength = card.code.size;
                        this.cardCvvMask = '#'.repeat(card.code.size);
                    }
                },
            },
        },
        methods: {
            ...mapActions('accept', ['dispatchAcceptData']),
            isNil,
            toggleShowBillingDetails() {
                this.showBillingDetails = !this.showBillingDetails;
            },
            refreshReservation(callback) {
                this.$emit('refreshReservations', callback);
            },
            getBillingCardData(data) {
                return {
                    cardType: data?.field1 || null,
                    cardExpirationDate: data?.field2 || null,
                    cardNumber: data?.field3 || null,
                    cardCvv: data?.field4 || null,
                    cardHolder: data?.field5 || null,
                    profileType: data?.profile_type || 0,
                    eCheckRoutingNumber: data?.field1 || null,
                    eCheckAccountNumber: data?.field2 || null,
                    eCheckAccountName: data?.field3 || null,
                    eCheckBankName: data?.field4 || null,
                    eCheckAccountType: data?.field5 || 'Checking',
                    eCheckCheckType: data?.field6 || 'Personal',
                };
            },
            toggleCardEdit() {
                if (this.profileTypeOptions.length == 1)
                    this.billingCard.profileType = this.profileTypeOptions[0].value;
                this.showEditCard = !this.showEditCard;
            },
            onCancel() {
                this.toggleCardEdit();
                this.billingCard.profileType = this.cardData.profile_type || 0;
            },
            async submitCard() {
                this.$emit('loading', true);
                try {
                    if (this.isProxy && this.isCreditCard) {
                        const response = await this.$refs.capture.submit();
                        this.$emit('loading', false);
                    } else if (this.metadata.use_setup_intent_guest) {
                        if (this.isCreditCard) {
                            this.saveStripeCard();
                        } else {
                            this.acceptEcheckPaymentMethod();
                        }
                    } else if (this.metadata.use_accept_js && (!this.metadata.is_proxy || this.isECheck)) {
                        const secureData = {};
                        secureData.authData = {
                            apiLoginID: this.metadata.auth_net_user_id,
                            clientKey: this.metadata.auth_net_publishable_key,
                        };

                        if (this.isCreditCard) {
                            const [month, year] = this.billingCard.cardExpirationDate.split('/');
                            secureData.cardData = {
                                cardNumber: this.billingCard.cardNumber.replaceAll(' ', ''),
                                month: month,
                                year: year,
                                cardCode: this.billingCard.cardCvv,
                                fullName: this.billingCard.cardHolder,
                            };
                        } else {
                            secureData.bankData = {
                                routingNumber: this.billingCard.eCheckRoutingNumber,
                                accountNumber: this.billingCard.eCheckAccountNumber,
                                nameOnAccount: this.billingCard.eCheckAccountName,
                                accountType: this.billingCard.eCheckAccountType,
                                bankName: this.billingCard.eCheckBankName,
                            };
                        }

                        const response = await this.dispatchAcceptData(secureData);
                        this.dataDescriptor = response.opaqueData.dataDescriptor;
                        this.dataValue = response.opaqueData.dataValue;

                        this.saveCard();
                    } else {
                        this.saveDeprecatedGatewayCard();
                    }
                } catch (err) {
                    this.showErrorToast({
                        text: 'Something went wrong while confirming payment information.',
                    });
                    this.$emit('loading', false);
                }
            },
            handleSuccessTokenizeCard(card) {
                this.cardToken = card.card_token;
                this.billingCard.cardType = convertFromBraintreeCardType(card.card_type);
                this.billingCard.cardNumber = card.card_number;
                this.billingCard.cardHolder = card.cardholder_name;
                this.billingCard.cardExpirationDate = `${card.expiration_month}/${card.expiration_year}`;
                this.saveCard();
                this.$refs.capture.fetchSessionToken();
            },
            async saveStripeCard() {
                this.$emit('loading', true);
                try {
                    try {
                        const res = await this.stripe.confirmCardSetup(this.reservation.stripe_client_secret, {
                            payment_method: {
                                card: this.card,
                                billing_details: { name: this.billingCard.cardHolder },
                            },
                        });
                        if (res.error) {
                            this.showErrorToast({ text: res.error.message });
                            return;
                        } else {
                            this.setupIntentId = res.setupIntent.id;
                        }
                    } catch {
                        this.showErrorToast({ text: 'Something went wrong while confirming card.' });
                        return;
                    }
                    if (this.setupIntentId) {
                        await API.post(
                            GUEST_RESERVATION_ADD_BILLING_DATA_STRIPE_ENDPOINT(
                                this.reservation.id,
                                this.reservation.user.id
                            ),
                            {
                                payment_type: 'card',
                                setup_intent_id: this.setupIntentId,
                            }
                        );
                        this.refreshReservation(() =>
                            this.showSuccessToast({ text: 'Credit Card successfully saved.' })
                        );
                        this.showEditCard = false;
                        this.card.clear();
                    }
                } catch (err) {
                    const { generic } = formatResponseError(err);
                    if (generic) {
                        this.errorModalMessage = generic;
                        this.$bvModal.show(this.subscriptionErrorModalId);
                    } else {
                        this.showErrorToast({ text: 'Something went wrong while saving credit card.' });
                    }
                } finally {
                    this.$emit('loading', false);
                    this.billingCard = this.getBillingCardData({});
                }
            },
            acceptEcheckPaymentMethod() {
                this.stripe
                    .confirmUsBankAccountSetup(this.reservation.stripe_client_secret, {
                        payment_method: {
                            us_bank_account: {
                                routing_number: this.billingCard.eCheckRoutingNumber,
                                account_number: this.billingCard.eCheckAccountNumber,
                                account_holder_type:
                                    this.billingCard.eCheckCheckType == 'Personal' ? 'individual' : 'company',
                                account_type: this.billingCard.eCheckAccountType.toLowerCase(),
                            },
                            billing_details: {
                                name: this.eCheckAccountHolderName,
                                email: this.eCheckEmail,
                            },
                        },
                    })
                    .then(async (result) => {
                        if (result.error) {
                            this.$emit('loading', false);
                            this.showErrorToast({ text: result.error.message });
                        } else {
                            if (['requires_action', 'requires_source_action'].includes(result.setupIntent.status)) {
                                // window.open(
                                //     result.setupIntent?.next_action?.verify_with_microdeposits?.hosted_verification_url,
                                //     '_blank'
                                // );
                                this.showPendingConfirmationModal = true;
                                this.addEcheckBillingData(result.setupIntent.id);
                            }
                            if (result.setupIntent.status.includes('succeeded')) {
                                this.addEcheckBillingData(result.setupIntent.id);
                            }
                        }
                    });
            },
            async addEcheckBillingData(setupIntentId) {
                try {
                    await API.post(
                        GUEST_RESERVATION_ADD_BILLING_DATA_STRIPE_ENDPOINT(
                            this.reservation.id,
                            this.reservation.user.id
                        ),
                        {
                            payment_type: 'eCheck',
                            setup_intent_id: setupIntentId,
                            account_holder_name: this.eCheckAccountHolderName,
                            account_type: this.billingCard.eCheckAccountType,
                            account_holder_type: this.billingCard.eCheckCheckType,
                            routing_number: this.billingCard.eCheckRoutingNumber,
                            account_number_last4: maskNumber(this.billingCard.eCheckAccountNumber).slice(-8),
                            bank_name: 'XXXXXXXXX',
                        }
                    );
                    this.refreshReservation(() =>
                        this.showSuccessToast({
                            text: `${
                                this.metadata.use_setup_intent_guest ? 'ACH Direct Debit' : 'eCheck'
                            } successfully saved.`,
                        })
                    );
                } catch (err) {
                    const { generic } = formatResponseError(err);
                    if (generic) {
                        this.errorModalMessage = generic;
                        this.$bvModal.show(this.subscriptionErrorModalId);
                    } else {
                        this.showErrorToast({
                            text: `Something went wrong while saving ${
                                this.metadata.use_setup_intent_guest ? 'ACH Direct Debit' : 'eCheck'
                            }.`,
                        });
                    }
                }
            },
            async saveDeprecatedGatewayCard() {
                this.$emit('loading', true);
                try {
                    let data = { profile_type: this.billingCard.profileType };
                    if (this.isCreditCard) {
                        data = {
                            ...data,
                            field1: this.billingCard.cardType,
                            field2: this.billingCard.cardExpirationDate,
                            field3: this.billingCard.cardNumber.replaceAll(' ', ''),
                            field4: this.billingCard.cardCvv,
                            field5: this.billingCard.cardHolder,
                            is_deprecated_gateway: true,
                        };
                    } else {
                        data = {
                            ...data,
                            field1: this.billingCard.eCheckRoutingNumber,
                            field2: this.billingCard.eCheckAccountNumber,
                            field3: this.billingCard.eCheckAccountName,
                            field4: this.billingCard.eCheckBankName,
                            field5: this.billingCard.eCheckAccountType,
                            field6: this.billingCard.eCheckCheckType,
                            is_deprecated_gateway: true,
                        };
                    }
                    await API.post(
                        GUEST_RESERVATION_ADD_BILLING_DATA_ENDPOINT(this.reservation.id, this.reservation.user.id),
                        data
                    );
                    this.refreshReservation(() =>
                        this.showSuccessToast({
                            text: this.isCreditCard
                                ? 'Credit Card successfully saved.'
                                : `${
                                      this.metadata.use_setup_intent_guest ? 'ACH Direct Debit' : 'eCheck'
                                  } data successfully saved.`,
                        })
                    );
                } catch (err) {
                    const { generic } = formatResponseError(err);
                    if (generic) {
                        this.errorModalMessage = generic;
                        this.$bvModal.show(this.subscriptionErrorModalId);
                    } else {
                        this.showErrorToast({ text: 'Something went wrong while saving credit card.' });
                    }
                } finally {
                    this.$emit('loading', false);
                    this.cardNumber = null;
                    this.billingCard = this.getBillingCardData({});
                }
            },
            async saveCard() {
                this.$emit('loading', true);
                try {
                    let data = { profile_type: this.billingCard.profileType };
                    if (this.isProxy && this.isCreditCard) {
                        data = { ...data, pci_token: this.cardToken };
                    } else {
                        data = { ...data, data_descriptor: this.dataDescriptor, data_value: this.dataValue };
                    }
                    if (this.isCreditCard) {
                        data = {
                            ...data,
                            field1: this.billingCard.cardType,
                            field2: this.billingCard.cardExpirationDate,
                            field3: maskNumber(this.billingCard.cardNumber.replaceAll(' ', '')).slice(-8),
                            field4: this.cardCvvMask,
                            field5: this.billingCard.cardHolder,
                        };
                    } else {
                        data = {
                            ...data,
                            field1: 'XXXXXXXXX',
                            field2: maskNumber(this.billingCard.eCheckAccountNumber).slice(-8),
                            field3: 'XXXXXXXXX',
                            field4: 'XXXXXXXXX',
                            field5: this.billingCard.eCheckAccountType,
                            field6: this.billingCard.eCheckCheckType,
                        };
                    }
                    await API.post(
                        GUEST_RESERVATION_ADD_BILLING_DATA_ENDPOINT(this.reservation.id, this.reservation.user.id),
                        data
                    );
                    this.refreshReservation(() =>
                        this.showSuccessToast({
                            text: this.isCreditCard
                                ? 'Credit Card successfully saved.'
                                : `${
                                      this.metadata.use_setup_intent_guest ? 'ACH Direct Debit' : 'eCheck'
                                  } data successfully saved.`,
                        })
                    );
                } catch (err) {
                    const { generic } = formatResponseError(err);
                    if (generic) {
                        this.errorModalMessage = generic;
                        this.$bvModal.show(this.subscriptionErrorModalId);
                    } else {
                        this.showErrorToast({ text: 'Something went wrong while saving credit card.' });
                    }
                } finally {
                    this.$emit('loading', false);
                    this.dataDescriptor = null;
                    this.dataValue = null;
                    this.cardToken = null;
                    this.cardNumber = null;
                    this.billingCard = this.getBillingCardData({});
                }
            },
            async deleteBillingData() {
                try {
                    this.$emit('loading', true);
                    await API.delete(
                        GUEST_RESERVATION_DELETE_BILLING_DATA_ENDPOINT(this.reservation.id, this.reservation.user.id)
                    );
                    this.$bvModal.hide(this.deleteBillingDataModalId);
                    this.refreshReservation(() =>
                        this.showSuccessToast({ text: 'Billing data successfully deleted.' })
                    );
                } catch (err) {
                    this.showErrorToast({ text: 'Could not delete billing data.' });
                } finally {
                    this.$emit('loading', false);
                }
            },
        },
        watch: {
            cardData(data) {
                this.showEditCard = false;
                this.displayBillingCard = this.getBillingCardData(data);
                this.billingCard = this.getBillingCardData({});
                this.billingCard.profileType = data?.profile_type || 0;
            },
            reservation() {
                setTimeout(() => {
                    if (this.showPendingConfirmationModal) this.$bvModal.show(this.pendingConfirmationModalId);
                }, 100);
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';
    @import '../../../../../scss/bootstrap-extended/bootstrap-extended.scss';

    .guest-invoices-billing {
        &__card {
            border: none !important;
            height: 100%;

            > :deep(.card-header) {
                background: linear-gradient(118deg, rgba($primary, 1), rgba($primary, 0.7));
                background-color: transparent !important;
                box-shadow: 0 0 10px 1px rgba($primary, 0.4);
                color: #fff;
                align-items: center;
                padding: 0 !important;
                justify-content: left !important;
                min-height: 50px;
            }

            :deep(&__header-icon) {
                font-size: 20px;
            }

            :deep(*) &__title {
                display: flex;
                align-items: center;
                font-size: 15px;
                justify-content: space-between;
                &__icon {
                    margin-right: 1.5rem;
                }
            }

            &__echeck-details {
                white-space: pre-line;
            }

            &__delete-billing-data {
                @include media-breakpoint-up(md) {
                    text-align: right;
                }
                @include media-breakpoint-down(md) {
                    margin-top: 2rem;
                    text-align: center;
                }
            }

            @include media-breakpoint-up(md) {
                :deep(&__card-buttons .btn) {
                    width: 150px;
                    margin-bottom: 0;
                }

                :deep(&__body span div) {
                    max-width: 455px;
                }
            }

            @include media-breakpoint-down(md) {
                :deep(&__card-buttons .btn) {
                    width: 100%;
                    margin-bottom: 10px;
                }

                :deep(&__body span div) {
                    max-width: 100%;
                }
            }

            @include media-breakpoint-down(sm) {
                :deep(&__body span div) {
                    max-width: none;
                }
            }
        }
    }

    .status-message {
        font-weight: 500 !important;

        @include media-breakpoint-up(md) {
            min-width: 400px !important;
        }

        @include media-breakpoint-down(md) {
            width: 100% !important;
        }
    }
</style>
